import { Button } from "@/components/ui/button";
import { MESSAGE } from "@/constants/message";

import { twMerge } from "tailwind-merge";

interface RetryErrorStateProps {
  onRetry: () => void;
  className?: string;
  title?: string;
  description?: string;
}

export default function RetryErrorState({
  onRetry,
  className,
  title = MESSAGE.WIDGET_CARD_ERROR_TO_RETRY_TITLE,
  description = MESSAGE.WIDGET_CARD_ERROR_TO_RETRY_DESCRIPTION
}: Readonly<RetryErrorStateProps>) {
  return (
    <div
      className={twMerge(
        "flex flex-col justify-center items-center gap-4 h-[400px]",
        className
      )}
    >
      <p className="font-semibold text-lg">{title}</p>
      <span className="text-xs w-1/2 text-center">{description}</span>
      <Button
        className="px-10 py-0 rounded-xl h-8"
        variant={"outline"}
        onClick={onRetry}
      >
        Retry
      </Button>
    </div>
  );
}
